import { useToast } from '@chakra-ui/react';
import { CartTotalResponse } from '@diamond/shared/types';
import { showToast } from '@diamond/shared/ui';
import { useCallback, useEffect, useRef } from 'react';

import { useVoucherStore } from '../stores';

export const useInvalidVoucherHandler = (
  cartTotalData: CartTotalResponse | undefined
) => {
  const toast = useToast();
  const prevInvalidVouchersRef = useRef<string[]>([]);

  const removeVouchers = useCallback((codes: string[]) => {
    useVoucherStore.getState().removeVouchers(codes);
  }, []);

  useEffect(() => {
    const invalidVouchers = cartTotalData?.vouchers?.invalid_vouchers || [];

    if (invalidVouchers.length === 0) {
      prevInvalidVouchersRef.current = [];
      return;
    }

    const newInvalidCodes = invalidVouchers
      .map((v) => v.voucher_code)
      .filter((code) => !prevInvalidVouchersRef.current.includes(code));

    if (newInvalidCodes.length > 0) {
      removeVouchers(newInvalidCodes);

      const voucherDetails = invalidVouchers
        .filter((v) => newInvalidCodes.includes(v.voucher_code))
        .map((v) => `"${v.voucher_code}"`)
        .join(', ');

      const reason =
        invalidVouchers.find((v) => newInvalidCodes.includes(v.voucher_code))
          ?.error_message || 'Produk yang dipilih tidak memenuhi syarat';

      showToast(
        toast,
        'warning',
        `Voucher tidak dapat digunakan karena belum sesuai dengan S&K yang berlaku`,
        undefined,
        'bottom',
        5000
      );

      prevInvalidVouchersRef.current = invalidVouchers.map(
        (v) => v.voucher_code
      );
    }
  }, [cartTotalData?.vouchers?.invalid_vouchers, removeVouchers, toast]);
};
